import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import Tooltip from '@atlaskit/tooltip';
export const MeatballMenuItem = ({
  isDisabled,
  tooltip,
  onClick,
  children
}) => {
  if (isDisabled) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      isDisabled: true
    }, children);
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip
  }, tooltipProps => /*#__PURE__*/React.createElement(DropdownItem, _extends({}, tooltipProps, {
    onClick: onClick
  }), children));
};